import { computed } from "@ember/object";
import RestModel from "discourse/models/rest";
import { getAbsoluteURL } from "discourse-common/lib/get-url";
export default class PublishedPage extends RestModel {
  get url() {
    return getAbsoluteURL(`/pub/${this.slug}`);
  }
  static #_ = (() => dt7948.n(this.prototype, "url", [computed("slug")]))();
}